import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {SnackbarService} from "services/snackbar.service";
import { AssistantActions } from "./action-types";
import {catchError, map, switchMap} from "rxjs/operators";
import {of} from "rxjs";
import {AssistantsApiFacade} from "../assistants-api.facade";

@Injectable()
export class AssistantEffects {

  createNeighbourMail$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AssistantActions.CreateNeighbourMail),
      switchMap(({ input, agentProfile, agentCompany }) =>
        this._assistantsApiFacade.createNeighbourMail$(input, agentProfile, agentCompany).pipe(
          map((result) => AssistantActions.CreateNeighbourMailSucceeded({ result })),
          catchError(() => of(AssistantActions.CreateNeighbourMailFailed()))
        )
      )
    )
  );

  createNeighbourMailSuccess$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateNeighbourMailSucceeded),
        map(({ result }) => {
          this._snackbarService.showSnackbar('Dokument erfolgreich erstellt!', 'mat-primary', true);
          console.log('createNeighbourMailSuccess$ result', result);
          // Trigger file download
          window.open(result.result, '_blank');
        })
      ),
    { dispatch: false }
  );

  createNeighbourMailFailed$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateNeighbourMailFailed),
        map(() =>
          this._snackbarService.showSnackbar('Fehler beim Erstellen des Dokuments.', 'mat-warn', true)
        )
      ),
    { dispatch: false }
  );

  createAlternativeSearch$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AssistantActions.CreateAlternativeSearch),
      switchMap(({ input, agentProfile, agentCompany }) =>
        this._assistantsApiFacade.createAlternativeSearch$(input, agentProfile, agentCompany).pipe(
          map((result) => AssistantActions.CreateAlternativeSearchSucceeded({ result })),
          catchError(() => of(AssistantActions.CreateAlternativeSearchFailed()))
        )
      )
    )
  );

  createAlternativeSearchSuccess$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateAlternativeSearchSucceeded),
        map(({ result }) => {
          this._snackbarService.showSnackbar('Dokument erfolgreich erstellt!', 'mat-primary', true);
          console.log('createAlternativeSearchSuccess$ result', result);
          // Trigger file download
          window.open(result.result, '_blank');
        })
      ),
    { dispatch: false }
  );

  createAlternativeSearchFailed$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateAlternativeSearchFailed),
        map(() =>
          this._snackbarService.showSnackbar('Fehler beim Erstellen des Dokuments.', 'mat-warn', true)
        )
      ),
    { dispatch: false }
  );

  createValuationMail$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AssistantActions.CreateValuationMail),
      switchMap(({ input, agentProfile, agentCompany }) =>
        this._assistantsApiFacade.createValuationMail$(input, agentProfile, agentCompany).pipe(
          map((result) => AssistantActions.CreateValuationMailSucceeded({ result })),
          catchError(() => of(AssistantActions.CreateValuationMailFailed()))
        )
      )
    )
  );

  createValuationMailSuccess$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateValuationMailSucceeded),
        map(({ result }) => {
          this._snackbarService.showSnackbar('Dokument erfolgreich erstellt!', 'mat-primary', true);
          // Trigger file download
          window.open(result.result, '_blank');
        })
      ),
    { dispatch: false }
  );

  createValuationMailFailed$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AssistantActions.CreateValuationMailFailed),
        map(() =>
          this._snackbarService.showSnackbar('Fehler beim Erstellen des Dokuments.', 'mat-warn', true)
        )
      ),
    { dispatch: false }
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _snackbarService: SnackbarService,
    private readonly _assistantsApiFacade: AssistantsApiFacade,
  ) {
  }
}
